export const bscPresaleAddress = "0x8Ab073005917eB98614Ae0BBFe9c3eF99144383B";
export const bnbUsdtAddress = "0x55d398326f99059fF775485246999027B3197955";
export const ethPresaleAddress = "0xEFc94f5254Fc2c5bB49318DD8CEaD8aB4ad99f2b";
export const ethUsdtAddress = "0xdAC17F958D2ee523a2206206994597C13D831ec7";
